import { QuoteClientViewProvider, type QuoteClientViewConfig } from './context';
import { QuoteDetailPageV2 } from './v2/QuoteDetailPageV2';

interface QuoteClientViewProps extends QuoteClientViewConfig {
	/**
	 * The quote to render. Taken as a prop rather than read from the router, so
	 * the same view works on any route that wants it.
	 */
	quoteId: string;
}

/**
 * A quote exactly as its client sees it.
 *
 * One implementation, rendered by the client portal and the guest shell alike.
 * The admin app used to render it too, inside a read-only preview modal; that
 * was removed in favour of previewing as a real guest, which is why nothing
 * here takes unsent batches or a seeded combination any more.
 *
 * It used to take a `design` prop and fork between two drawings of the page —
 * the rebuild on `@codezo/quote-detail` and the two-column page it replaced.
 * The old one went with combination plans, whose card was the last thing it
 * drew that this one did not.
 */
export function QuoteClientView({ quoteId, ...config }: QuoteClientViewProps) {
	return (
		<QuoteClientViewProvider {...config}>
			<QuoteDetailPageV2 quoteId={quoteId} />
		</QuoteClientViewProvider>
	);
}
